import { observer } from "mobx-react-lite";
import ConsoleIframe from "../../../components/Home/Iframe/ConsoleIframe";

const TgIframe = () => {
	return <ConsoleIframe translationPrefix="iframe" />;
};

export default observer(TgIframe);
